import { collection, query, where, getDocs, onSnapshot, updateDoc, doc } from 'firebase/firestore';
import { firestore } from '../../firebase';
import { normalizeComplaintStatus } from '../../utils/complaintStatus';

export const getItemsByShopEmail = (shopEmail, onUpdate) => {
  const itemQuery = query(
    collection(firestore, 'ItemMaster'),
    where('shopEmail', '==', shopEmail)
  );

  const unsubscribe = onSnapshot(itemQuery, async (querySnapshot) => {
    const itemsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    const userPromises = itemsData.map(async (item) => {
      const userQuery = query(
        collection(firestore, 'UserProfileMaster'),
        where('uid', '==', item.userId)
      );
      const userSnapshot = await getDocs(userQuery);
      const userData = userSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      const complaintsQuery = query(
        collection(firestore, 'Complaints'),
        where('itemId', '==', item.id)
      );
      const complaintsSnapshot = await getDocs(complaintsQuery);
      const complaintsData = complaintsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      return {
        ...item,
        userData: userData.length > 0 ? userData[0] : null,
        complaints: complaintsData,
      };
    });

    const itemsWithUserDetails = await Promise.all(userPromises);
    onUpdate(itemsWithUserDetails);
  });

  return unsubscribe;
};

export const listenToComplaints = (onUpdate) => {
  const unsubscribe = onSnapshot(
    collection(firestore, 'Complaints'),
    (querySnapshot) => {
      const complaintsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      onUpdate(complaintsData);
    }
  );
  
  return unsubscribe;
};

export const updateComplaintStatus = async (complaintId, newStatus, extraFields = {}) => {
  const complaintRef = doc(firestore, 'Complaints', complaintId);
  await updateDoc(complaintRef, {
    status: normalizeComplaintStatus(newStatus),
    ...extraFields,
  });
};
